<template>
  <div>
    <!-- Užsakymas -->
    <v-toolbar flat color="white">
      <v-toolbar-title>{{ $t("products_crud.order") }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <router-link
        :to="{ name: 'pallet-planning', params: { filter: order.toString() } }"
      >{{ $t("products_crud.edit") }}</router-link>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-data-table :headers="orderHeaders" :items="[order]" hide-actions class="elevation-1">
      <template v-slot:items="props">
        <td>{{ props.item.offer_id }}</td>
        <td class="text-xs-left">{{ props.item.production_id }}</td>
        <td class="text-xs-left">{{ getCustomer(props.item) }}</td>
        <td class="text-xs-left">{{ getContactName(props.item) }}</td>
        <td class="text-xs-left">{{ getContactMobile(props.item) }}</td>
        <td class="text-xs-left">{{ getContactEmail(props.item) }}</td>
        <td class="text-xs-left">{{ props.item.address }}</td>
        <td class="text-xs-left">{{ props.item.delivery_date }}</td>
        <td class="text-xs-left">{{ props.item.status }}</td>
      </template>
    </v-data-table>

    <!-- Produktai -->
    <v-toolbar flat color="white">
      <v-toolbar-title>{{ $t("products_crud.products") }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        class="mb-2"
        :disabled="selected.length < 1"
        @click="openPrintPdf"
      >{{$t('products_crud.product_pdf')}}</v-btn>
      <v-btn
        v-if="user.type != 6"
        color="primary"
        class="mb-2"
        :disabled="selected.length < 1"
        @click="openEditProducts"
      >{{ $t("products_crud.edit") }}</v-btn>
      <v-btn
        v-if="user.type != 6"
        color="primary"
        class="mb-2"
        :disabled="selected.length < 1"
        @click="openCommentProducts"
      >{{ $t("products_crud.comment") }}</v-btn>
      <v-btn
        v-if="user.type != 6"
        color="primary"
        dark
        class="mb-2"
        @click="openNewProduct"
      >{{ $t("products_crud.new_product") }}</v-btn>
    </v-toolbar>
    <!-- product data -->
    <div class="table-wrapper">
      <div class="progress-wrapper">
        <v-progress-linear :indeterminate="false"></v-progress-linear>
      </div>
      <div class="rTable">
        <div class="rTableRow problem-header">
          <div class="rTableHead" :style="{ 'width': 2 + '%'}">
            <input id="products-checkbox" type="checkbox" @click="selectAllProducts($event)" />
          </div>
          <div
            class="rTableHead"
            v-for="(header, i) in productsHeaders"
            :key="i"
            :style="{ 'width': header.width + '%'}"
          >{{header.text}}</div>
        </div>
        <div class="rTableRow" v-for="(product, i ) in getProductsList()" :key="i">
          <div class="rTableCell">
            <input class="product-checkbox" type="checkbox" @click="selectProduct($event, product)" />
          </div>
          <div class="rTableCell">{{product.barcode}}</div>
          <div class="rTableCell number-cell">{{product.position}}</div>
          <div class="rTableCell">{{product.type}}</div>
          <div class="rTableCell number-cell">{{product.width}}</div>
          <div class="rTableCell number-cell">{{product.height}}</div>
          <div class="rTableCell number-cell">{{product.depth}}</div>
          <div class="rTableCell number-cell">{{product.weight}}</div>
          <div class="rTableCell number-cell">{{product.area}}</div>
          <div class="rTableCell">{{palletNumber(product.pallet)}}</div>
          <div class="rTableCell">{{getCategory(product)}}</div>
          <div class="rTableCell">
            <change-status-to
              @statusChanged="initialize"
              :id="product.id"
              :statusNames="statusNames"
              :statusRights="statusRights"
              :user="user"
              :currentStatus="product.status"
              :table="'products'"
            />
          </div>
          <div class="rTableCell">{{partOf(product)}}</div>
          <div class="rTableCell">{{product.comment}}</div>
          <div class="rTableCell">
            <status-changes
              :item="product"
              :table="'product'"
              v-tooltip="$t('products_crud.view_changes')"
            ></status-changes>
            <v-icon
              v-if="user.type != 6"
              small
              class="mr-2"
              @click="commentProduct(product)"
              v-tooltip="$t('products_crud.comment')"
            >comment</v-icon>
            <v-icon
              small
              class="mr-2"
              @click="viewSet(product)"
              v-tooltip="$t('products_crud.set')"
            >zoom_in</v-icon>
            <v-icon
              v-if="user.type != 6"
              small
              class="mr-2"
              @click="deleteProduct(product)"
              v-tooltip="$t('products_crud.delete')"
            >delete</v-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="products-preview" v-if="Object.entries(order).length != 0">
      <order-products-preview :products="order.products" />
    </div>
    <Product-Edit ref="productEdit" @updated="initialize"></Product-Edit>
    <OrderProductMaker ref="orderProductMaker" @created="productCreated" />
    <ProductPdfDialog v-if="templates.length > 0" ref="productPdfDialog" :templates="templates" />
  </div>
</template>

<script>
import StatusChanges from "@/components/status-changes/StatusChanges.vue";
import ChangeStatusTo from "@/components/status-changes/StatusChangeTo.vue";
import OrderProductsPreview from "@/components/orders/OrderProductsPreview.vue";
import HttpClient from "@/models/HttpClient.js";
import Order from "@/models/Order.js";
import User from "@/models/User.js";
import PdfTemplate from "@/models/PdfTemplate.js";
import ProductEdit from "@/components/orders/ProductEdit.vue";
import OrderProductMaker from "@/components/orders/OrderProductMaker.vue";
import ProductPdfDialog from "@/components/orders/ProductPdfDialog.vue";

export default {
  name: "product-list",
  components: {
    StatusChanges,
    OrderProductMaker,
    ChangeStatusTo,
    OrderProductsPreview,
    ProductEdit,
    ProductPdfDialog,
  },
  data() {
    return {
      selected: [],
      statusRights: this.$session.get("statusRights"),
      statusNames: this.$session.get("statusNames").filter((e) => {
        return e.table_name == "products";
      }),
      orderId: this.$route.params.id,
      order: {},
      dialog: false,
      orderHeaders: getOrderHeaders(this),
      productsHeaders: getProductHeaders(this),
      editedIndex: -1,
      editedItem: {
        barcode: null,
        position: null,
        type: null,
        width: null,
        height: null,
        depth: null,
        weight: null,
        area: null,
        status: 0,
      },
      defaultItem: {
        barcode: null,
        position: null,
        type: null,
        width: null,
        height: null,
        depth: null,
        weight: null,
        area: null,
        status: 0,
      },
      user: new User(this.$session.get("user")),
      client: new HttpClient(),
      templates: [],
    };
  },

  async created() {
    this.templates = await PdfTemplate.loadTemplates();
    this.initialize();
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  computed: {
    formType() {
      return this.editedIndex === -1;
    },

    formTitle() {
      return this.editedIndex === -1
        ? this.$t("products_crud.new_product")
        : this.$t("products_crud.edit_product");
    },
  },

  methods: {
    /**
     * loads products from the database
     */
    async initialize() {
      const response = await this.client.instance.get(
        `orders/${this.orderId}`,
        {
          params: {
            with_product_images: true,
          },
        }
      );
      this.order = new Order(response.data);
      this.unselectAll();
    },

    unselectAll() {
      this.selected = [];
      const checkboxes = document.getElementsByClassName("product-checkbox");
      for (const checkbox of checkboxes) {
        checkbox.checked = false;
      }
      document.getElementById("products-checkbox").checked = false;
    },

    selectAllProducts(event) {
      const checkboxes = document.getElementsByClassName("product-checkbox");
      for (const product of this.getProductsList()) {
        this.selectProduct(event, product);
      }
      for (const checkbox of checkboxes) {
        checkbox.checked = event.target.checked;
      }
    },

    selectProduct(event, product) {
      if (event.target.checked) {
        this.addSelected(product);
      } else {
        this.removeSelected(product);
      }
    },

    addSelected(newProduct) {
      const found = this.selected.find((product) => {
        return product.id === newProduct.id;
      });
      if (!found) {
        this.selected.push(newProduct);
      }
    },

    removeSelected(newProduct) {
      const palletIndex = this.selected.indexOf(newProduct);
      if (palletIndex != -1) {
        this.selected.splice(palletIndex, 1);
      }
    },

    partOf(product) {
      if (product.part_of != null) {
        return this.$t("products_crud.yes");
      }
      return "";
    },

    productCreated() {
      this.selected = [];
      this.initialize();
    },

    /**
     * edit selected product in the database
     *
     * @param product id
     */
    async editProduct(product) {
      const data = formData(product, this);
      if (this.validateData(data)) {
        await product.save(data);
        this.initialize();
      } else {
        alert(this.$t("products_crud.product_request_error"));
      }
    },

    /**
     * validates data before send
     *
     * @param data - data to be checked
     */
    validateData(data) {
      let Validator = require("validatorjs");
      let rules = {
        area: "required|numeric",
        barcode: "required|string|min:1|max:64",
        depth: "required|integer",
        height: "required|integer",
        isFlipped: "boolean",
        palletId: "integer",
        position: "required|string|min:1|max:64",
        status: "required|integer",
        type: "min:1|max:191",
        weight: "required|integer",
        width: "required|integer",
        x: "integer",
        y: "integer",
        z: "integer",
      };
      let validation = new Validator(data, rules);
      return validation.passes() ? true : false;
    },

    commentProduct(product) {
      this.$refs.productEdit.openComment(product);
    },

    viewSet(product) {
      this.$router.push({
        name: "product-set",
        params: { barcode: product.barcode },
      });
    },

    /**
     * deletes item form database
     *
     * @param product selected product
     */
    async deleteProduct(product) {
      if (!this.user.hasRights("OP_DEL")) {
        alert(this.$t("products_crud.no_right_to_delete_product"));
        return 0;
      }
      const confirmed = confirm(this.$t("products_crud.delete_confirm"));
      if (confirmed) {
        await product.delete();
        this.initialize();
      }
    },

    /**
     * closes dialog
     */
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    /**
     * edits product in the database
     */
    edit() {
      this.editProduct(this.editedItem);
      this.close();
    },

    /**
     * is customer is set, returns name
     */
    getCustomer(order) {
      if (order["customer"] != null) {
        return order["customer"]["name"];
      }
      return "";
    },

    /**
     *
     * gets orders contact name
     * @param order
     */
    getContactName(order) {
      if (order.contact == null) {
        return "";
      }
      return order.contact.name;
    },

    /**
     * gets orders contact mobile
     * @param order
     */
    getContactMobile(order) {
      if (order.contact == null) {
        return "";
      }
      return order.contact.mobile;
    },

    /**
     * gets orders contact email
     * @param order
     */
    getContactEmail(order) {
      if (order.contact == null) {
        return "";
      }
      return order.contact.email;
    },

    /**
     * returns pallet number if exists
     */
    palletNumber(pallet) {
      if (pallet == null) {
        return "-";
      }
      return pallet.getNumber();
    },

    getCategory(product){
      return product.getCategory(this);
    },

    openPrintPdf(){
      if(this.$refs.productPdfDialog){
        this.$refs.productPdfDialog.open(this.selected);
      }
    },

    openEditProducts() {
      this.$refs.productEdit.openEdit(this.selected);
    },

    openCommentProducts() {
      this.$refs.productEdit.openComment(this.selected);
    },

    openNewProduct() {
      this.$refs.orderProductMaker.open(this.order, this.selected);
    },

    getProductsList() {
      if (Object.keys(this.order).length > 0) {
        return this.order.getFilteredProducts();
      }
      return [];
    },
  },
};

function getOrderHeaders(vue) {
  return [
    {
      text: vue.$t("products_crud.offer_id"),
      align: "left",
      value: "offer_id",
      sortable: false,
    },
    {
      text: vue.$t("products_crud.production_id"),
      value: "production_id",
      sortable: false,
    },
    {
      text: vue.$t("products_crud.customer"),
      value: "customer",
      sortable: false,
    },
    {
      text: vue.$t("products_crud.name"),
      value: "customer",
      sortable: false,
    },
    {
      text: vue.$t("products_crud.mobile"),
      value: "customer",
      sortable: false,
    },
    {
      text: vue.$t("products_crud.email"),
      value: "customer",
      sortable: false,
    },
    {
      text: vue.$t("products_crud.delivery_address"),
      value: "address",
      sortable: false,
    },
    {
      text: vue.$t("products_crud.delivery_date"),
      value: "delivery_date",
      sortable: false,
    },
    { text: vue.$t("products_crud.status"), value: "status", sortable: false },
  ];
}

function getProductHeaders(vue) {
  return [
    {
      text: vue.$t("products_crud.barcode"),
      align: "left",
      value: "barcode",
    },
    { text: vue.$t("products_crud.position"), value: "position" },
    { text: vue.$t("products_crud.type"), value: "type" },
    { text: vue.$t("products_crud.width"), value: "width" },
    { text: vue.$t("products_crud.height"), value: "height" },
    { text: vue.$t("products_crud.depth"), value: "depth" },
    { text: vue.$t("products_crud.weight"), value: "weight" },
    { text: vue.$t("products_crud.area"), value: "area" },
    {
      text: vue.$t("products_crud.pallet"),
      value: "pallet.name",
      sortable: false,
    },
    { text: vue.$t("products_crud.category"), value: "category" },
    { text: vue.$t("products_crud.status"), value: "status" },
    {
      text: vue.$t("products_crud.part"),
      value: "part_of",
    },
    { text: vue.$t("products_crud.comment"), value: "comment" },
    { text: vue.$t("products_crud.actions"), sortable: false },
  ];
}

/**
 * formats data before sending to the database
 *
 * @param product - product obj
 */
function formData(product, vue) {
  let data = {
    status: product.status,
    order_id: vue.order.id,
  };
  if (product.position != null) data["position"] = product.position;
  if (product.barcode != null) data["barcode"] = product.barcode;
  if (product.type != null) data["type"] = product.type;
  if (product.height != null) data["height"] = product.height;
  if (product.width != null) data["width"] = product.width;
  if (product.depth != null) data["depth"] = product.depth;
  if (product.weight != null) data["weight"] = product.weight;
  if (product.palletId != null) data["palletId"] = product.palletId;
  if (product.x != null) data["x"] = product.x;
  if (product.y != null) data["y"] = product.y;
  if (product.z != null) data["z"] = product.z;
  if (product.isFlipped != null) data["isFlipped"] = product.isFlipped;
  if (product.area != null) data["area"] = product.area;
  if (product.comment != null) data["comment"] = product.comment;
  return data;
}
</script>

<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 10px;
}
.products-preview {
  margin-top: 20px;
  width: 100%;
}
</style>
